<div mat-dialog-header>
  <h1>
    Account Monitor History <span> - {{ data.accountDetail?.AccountID }}</span>
  </h1>
</div>
<mat-dialog-content class="dialog-container row">
  <div class="annuity-exchange-container info-card mb-4">
    <table>
      <thead>
        <tr>
          <th></th>
          @for (header of accountReviewKey; track header.label) {
            <th>{{ header.label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (
          accountReview of data.accountDetail?.AccountHistory;
          track accountReview
        ) {
          <tr>
            <td class="action-container">
              <span>
                <button
                  matSuffix
                  mat-icon-button
                  color="primary"
                  matTooltip="View account history event"
                  (click)="viewHistoryEvent(accountReview)"
                >
                  <mat-icon>preview</mat-icon>
                </button>
              </span>
            </td>
            @for (header of accountReviewKey; track header.label) {
              @if (header.key) {
                <td>{{ header.key[accountReview[header.varName]] }}</td>
              } @else {
                <td>{{ accountReview[header.varName] }}</td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="buttons">
  <button mat-raised-button (click)="cancel()">Close</button>
</mat-dialog-actions>
